module.exports = __webpack_public_path__ + "fonts/SUIT-Heavy.70bb2b30.woff2";